import React from 'react';
import { ZoomOut, ZoomIn, RotateCcw } from 'lucide-react';

interface ZoomControlsProps {
  zoom: number;
  onZoomChange: (zoom: number) => void;
}

export default function ZoomControls({ zoom, onZoomChange }: ZoomControlsProps) {
  const minZoom = 50;
  const maxZoom = 200;
  const step = 10;

  const handleZoomOut = () => {
    onZoomChange(Math.max(minZoom, zoom - step));
  };

  const handleZoomIn = () => {
    onZoomChange(Math.min(maxZoom, zoom + step));
  };

  const handleReset = () => {
    onZoomChange(100);
  };

  return (
    <div className="space-y-2">
      <div className="flex items-center justify-between text-sm text-muted-foreground mb-1">
        <span>Zoom Level</span>
        <span className="font-medium text-foreground">{zoom}%</span>
      </div>
      
      <input
        type="range"
        min={minZoom}
        max={maxZoom}
        step={step}
        value={zoom}
        onChange={(e) => onZoomChange(Number(e.target.value))}
        className="w-full h-2 bg-muted rounded-lg appearance-none cursor-pointer accent-primary"
      />
      
      <div className="flex gap-1">
        <button
          onClick={handleZoomOut}
          disabled={zoom <= minZoom}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium bg-muted hover:bg-muted/80 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ZoomOut className="w-3 h-3" />
          Out
        </button>
        <button
          onClick={handleReset}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium bg-muted hover:bg-muted/80 rounded transition-colors"
        >
          <RotateCcw className="w-3 h-3" />
          Reset
        </button>
        <button
          onClick={handleZoomIn}
          disabled={zoom >= maxZoom}
          className="flex-1 flex items-center justify-center gap-1 px-2 py-1.5 text-xs font-medium bg-muted hover:bg-muted/80 rounded transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          <ZoomIn className="w-3 h-3" />
          In
        </button>
      </div>
    </div>
  );
}
